import Reveal from "@/components/Reveal";
import { LinkButton } from "@/components/Button";

const CTASection = ({
  title = "Have a Project in Mind?",
  description = "Let's discuss your ideas and turn them into a powerful digital product.",
  cta = "Let's Talk",
  to = "/contact",
}) => (
  <section className="container-x pb-24 pt-4" data-testid="cta-section">
    <Reveal>
      <div className="relative overflow-hidden rounded-3xl border border-kryvo-line bg-gradient-to-b from-white to-kryvo-mist px-6 py-16 text-center sm:px-12 sm:py-20 lg:py-24">
        <div
          className="animate-cta-drift pointer-events-none absolute -left-24 -top-24 h-80 w-80 rounded-full bg-kryvo-lime/30 blur-3xl"
          aria-hidden="true"
        />
        <div
          className="animate-cta-drift pointer-events-none absolute -bottom-32 -right-16 h-96 w-96 rounded-full bg-kryvo-green/10 blur-3xl [animation-delay:-7s]"
          aria-hidden="true"
        />
        <svg
          className="pointer-events-none absolute inset-0 h-full w-full opacity-[0.05]"
          aria-hidden="true"
        >
          <defs>
            <pattern id="cta-grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M40 0H0v40" fill="none" stroke="#087A3D" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#cta-grid)" />
        </svg>

        <div className="relative mx-auto flex max-w-2xl flex-col items-center gap-6">
          <span className="eyebrow" data-testid="cta-eyebrow">
            <span className="h-px w-6 bg-kryvo-lime" aria-hidden="true" />
            Let's Build
          </span>
          <h2 className="text-balance text-3xl font-semibold text-kryvo-ink sm:text-4xl lg:text-5xl">
            {title}
          </h2>
          <p className="max-w-xl text-base leading-relaxed text-kryvo-sub sm:text-lg">{description}</p>
          <LinkButton to={to} variant="primary" testId="cta-section-button" className="mt-2">
            {cta}
          </LinkButton>
        </div>
      </div>
    </Reveal>
  </section>
);

export default CTASection;
